// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"774":"dab4b4e3","782":"ecd2dc1c"}[chunkId] + ".chunk.js";
};